<template>
  <div class="project-documents">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <b-row v-if="isUploadVisible">
      <b-col lg="6" md="6" sm="12">
        <legend>
          <strong>{{ $t('upload') }}</strong>
        </legend>

        <b-form-group
          horizontal
          :label="$t('projectAttachmentType')"
          label-for="projectAttachmentType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('projectAttachmentType')"
            v-model="selectedProjectAttachmentType"
            id="projectAttachmentType"
            :options="filteredProjectAttachmentTypes"
            :allow-empty="false"
            :show-labels="false"
            v-on:search-change="onProjectAttachmentTypeSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>

          <DropzoneUpload
            class="mt-2"
            :complete="isAttachmentUploadComplete"
            :parentId="project.id"
            :parentType="selectedProjectAttachmentType"
            :uploadCallback="onUploadProjectAttachments"
            :disabled="isUploadDisabled"
            :multiUpload="true"
            v-on:dropzone-upload:reset="isAttachmentUploadComplete = false"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!isNewProject">
      <b-col lg="6" md="6" sm="12">
        <div class="accordion" role="tablist">
          <!-- VLINK Dokumente -->
          <!-- <AccordionSimpleCard cardId="accordion-vlinkAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('vlinkAttachments') }}

              </slot>
            </template>

            <AttachmentGallery
              :attachments="project.vlinkAttachments"
              attachmentType="vlinkAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>
          </AccordionSimpleCard> -->

          <!-- Unterlagen Auftraggeber -->
          <AccordionSimpleCard cardId="accordion-installationImageAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('installationImageAttachments') }}
                <ZipDownload
                  attachmentType="installationImageAttachments"
                  :attachments="project.installationImageAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>

            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.installationImageAttachments"
              attachmentType="installationImageAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>
          </AccordionSimpleCard>

          <!-- Bilder Aufmaß -->
          <AccordionSimpleCard cardId="accordion-measurementAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('measurementReport') }}
                <ZipDownload
                  attachmentType="measurementReportImageAttachments"
                  :attachments="project.measurementReportImageAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>

            <legend>
              <strong>{{ $t('measurementAttachments') }} - Allgemein</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.measurementAttachments"
              attachmentType="measurementAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Ziegel vermörtelt ? - Zusätzliches Foto -->
            <legend>
              <strong>{{ $t('bricksPlasteredAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.bricksPlasteredAttachments"
              attachmentType="bricksPlasteredAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Pappdocken vorhanden? - Zusätzliches Foto-->
            <legend>
              <strong>{{ $t('cardboardPoppetAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cardboardPoppetAttachments"
              attachmentType="cardboardPoppetAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('pedimentAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.pedimentAttachments"
              attachmentType="pedimentAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('pitchedRoof') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.pitchedRoofOptionalAttachments"
              attachmentType="pitchedRoofOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('rafterVisibleAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.rafterVisibleAttachments"
              attachmentType="rafterVisibleAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('rafter') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.rafterOptionalAttachments"
              attachmentType="rafterOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('outerRoof') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.outerRoofOptionalAttachments"
              attachmentType="outerRoofOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('bricksFrontAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.bricksFrontAttachments"
              attachmentType="bricksFrontAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('bricksBackAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.bricksBackAttachments"
              attachmentType="bricksBackAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('bricks') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.bricksOptionalAttachments"
              attachmentType="bricksOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofSidesAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofSidesAttachments"
              attachmentType="roofSidesAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofSidesShadowsAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofSidesShadowsAttachments"
              attachmentType="roofSidesShadowsAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofSidesSketchAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofSidesSketchAttachments"
              attachmentType="roofSidesSketchAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofSides') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofSidesOptionalAttachments"
              attachmentType="roofSidesOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofAccessAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofAccessAttachments"
              attachmentType="roofAccessAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofAccess') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofAccessOptionalAttachments"
              attachmentType="roofAccessOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('hakAndZsSameRoomAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.hakAndZsSameRoomAttachments"
              attachmentType="hakAndZsSameRoomAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('hakAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.hakAttachments"
              attachmentType="hakAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('hak') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.hakOptionalAttachments"
              attachmentType="hakOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('zsWithCoverAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.zsWithCoverAttachments"
              attachmentType="zsWithCoverAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('zsWithoutCoverAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.zsWithoutCoverAttachments"
              attachmentType="zsWithoutCoverAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('zs') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.zsOptionalAttachments"
              attachmentType="zsOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('mainElectricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.mainElectricMeterAttachments"
              attachmentType="mainElectricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('seconaryElectricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.seconaryElectricMeterAttachments"
              attachmentType="seconaryElectricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('electricMeter') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.electricMeterOptionalAttachments"
              attachmentType="electricMeterOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('acInstallationLocationAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.acInstallationLocationAttachments"
              attachmentType="acInstallationLocationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('locationAndCable') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.locationAndCablePathOptionalAttachments"
              attachmentType="locationAndCablePathOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('equipotentialBusBarPresentAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.equipotentialBusBarPresentAttachments"
              attachmentType="equipotentialBusBarPresentAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('earthingPresentAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.earthingPresentAttachments"
              attachmentType="earthingPresentAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('earthingUnit') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.earthingOptionalAttachments"
              attachmentType="earthingOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('internetConnection') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.internetConnectionAttachments"
              attachmentType="internetConnectionAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('heavyCurrentPresentAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.heavyCurrentPresentAttachments"
              attachmentType="heavyCurrentPresentAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('wallboxLocationAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.wallboxLocationAttachments"
              attachmentType="wallboxLocationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('wallbox') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.wallboxOptionalAttachments"
              attachmentType="wallboxOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('flatRoofSurfaceAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.flatRoofSurfaceAttachments"
              attachmentType="flatRoofSurfaceAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('flatRoof') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.flatRoofOptionalAttachments"
              attachmentType="flatRoofOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>
          </AccordionSimpleCard>

          <!-- Acceptance Report Attachments -->
          <AccordionSimpleCard cardId="accordion-acceptanceReportAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('enpal_report') }}
                <ZipDownload
                  attachmentType="acceptanceReportImageAttachments"
                  :attachments="project.acceptanceReportImageAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>

            <!-- Existing Damage Section -->
            <legend>
              <strong>{{ $t('damageAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.damageAttachments"
              attachmentType="damageAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Job Safety Section -->
            <legend>
              <strong>{{ $t('scaffoldAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.scaffoldAttachments"
              attachmentType="scaffoldAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('jobSafety') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.jobSafetyOptionalAttachments"
              attachmentType="jobSafetyOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Ballast Section -->
            <legend>
              <strong>{{ $t('ballastAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.ballastAttachments"
              attachmentType="ballastAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('railToRoofDistanceAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.railToRoofDistanceAttachments"
              attachmentType="railToRoofDistanceAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('earthingSubstructureAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.earthingSubstructureAttachments"
              attachmentType="earthingSubstructureAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Brick and Substructure Section -->
            <legend>
              <strong>{{ $t('brickCoverWidthAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.brickCoverWidthAttachments"
              attachmentType="brickCoverWidthAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('correctBrickHandlingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.correctBrickHandlingAttachments"
              attachmentType="correctBrickHandlingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('roofHookWithEarthingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.roofHookWithEarthingAttachments"
              attachmentType="roofHookWithEarthingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('correctCableInputAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.correctCableInputAttachments"
              attachmentType="correctCableInputAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('protectedUnderBrickCableRoutingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.protectedUnderBrickCableRoutingAttachments"
              attachmentType="protectedUnderBrickCableRoutingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('brickAndSubstructureAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.brickAndSubstructureAttachments"
              attachmentType="brickAndSubstructureAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong
                >{{ $t('brickAndSubstructureAttachments') }} {{ $t('optionalAttachments') }}</strong
              >
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.brickAndSubstructureOptionalAttachments"
              attachmentType="brickAndSubstructureOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Solar Panels Section -->
            <legend>
              <strong>{{ $t('stringPlanAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.stringPlanAttachments"
              attachmentType="stringPlanAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('allPanelsVisibleAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.allPanelsVisibleAttachments"
              attachmentType="allPanelsVisibleAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('clampAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.clampAreaAttachments"
              attachmentType="clampAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('trayfDistanceAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.trayfDistanceAttachments"
              attachmentType="trayfDistanceAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('railOverlapAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.railOverlapAttachments"
              attachmentType="railOverlapAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('panelBottomViewAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.panelBottomViewAttachments"
              attachmentType="panelBottomViewAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('solarModuleTypePlateAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.solarModuleTypePlateAttachments"
              attachmentType="solarModuleTypePlateAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('solarPanels') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.solarPanelsOptionalAttachments"
              attachmentType="solarPanelsOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Cable Management Section -->
            <legend>
              <strong>{{ $t('cableManagementAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cableManagementAttachments"
              attachmentType="cableManagementAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('cableAlongFacadeAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cableAlongFacadeAttachments"
              attachmentType="cableAlongFacadeAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('cableManagement') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cableManagementOptionalAttachments"
              attachmentType="cableManagementOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Inverter Section -->
            <legend>
              <strong>{{ $t('inverterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.inverterAttachments"
              attachmentType="inverterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('inverterSerialNumberAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.inverterSerialNumberAttachments"
              attachmentType="inverterSerialNumberAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('mateboxSerialNumberAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.mateboxSerialNumberAttachments"
              attachmentType="mateboxSerialNumberAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('storageSerialNumberAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.storageSerialNumberAttachments"
              attachmentType="storageSerialNumberAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('dongleSerialNumberAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.dongleSerialNumberAttachments"
              attachmentType="dongleSerialNumberAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('openMateboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.openMateboxAttachments"
              attachmentType="openMateboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('cableBetweenMateboxAndElectricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cableBetweenMateboxAndElectricMeterAttachments"
              attachmentType="cableBetweenMateboxAndElectricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('variousBreakthroughsWithPossibleSealingsAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.variousBreakthroughsWithPossibleSealingsAttachments"
              attachmentType="variousBreakthroughsWithPossibleSealingsAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('inverter') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.inverterOptionalAttachments"
              attachmentType="inverterOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Potential Section -->
            <legend>
              <strong>{{ $t('equipotentialBusBarAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.equipotentialBusBarAttachments"
              attachmentType="equipotentialBusBarAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('potentialGroundRodAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.potentialGroundRodAttachments"
              attachmentType="potentialGroundRodAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('potential') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.potentialOptionalAttachments"
              attachmentType="potentialOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- HAK Section -->
            <legend>
              <strong>{{ $t('openHAKAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.openHAKAttachments"
              attachmentType="openHAKAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('closedHAKWithSealAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.closedHAKWithSealAttachments"
              attachmentType="closedHAKWithSealAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Electric Meter Section -->
            <legend>
              <strong>{{ $t('electricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.electricMeterAttachments"
              attachmentType="electricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('electricMeterReadingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.electricMeterReadingAttachments"
              attachmentType="electricMeterReadingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('gakAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.gakAttachments"
              attachmentType="gakAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('openMeterCabinetPrePostAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.openMeterCabinetPrePostAreaAttachments"
              attachmentType="openMeterCabinetPrePostAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('closedMeterCabinetInscribedComponentsAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.closedMeterCabinetInscribedComponentsAttachments"
              attachmentType="closedMeterCabinetInscribedComponentsAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('closedPreMeterAreaWithPlombsAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.closedPreMeterAreaWithPlombsAttachments"
              attachmentType="closedPreMeterAreaWithPlombsAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('breakthroughsWithSealingsMeterCabinetAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.breakthroughsWithSealingsMeterCabinetAttachments"
              attachmentType="breakthroughsWithSealingsMeterCabinetAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('electricMeter') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.electricMeterAndGakOptionalAttachments"
              attachmentType="electricMeterAndGakOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Wallbox Section -->
            <legend>
              <strong>{{ $t('photoOfWallboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.photoOfWallboxAttachments"
              attachmentType="photoOfWallboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('accessCardsOfWallboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.accessCardsOfWallboxAttachments"
              attachmentType="accessCardsOfWallboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('circuitBreakerAndSafetySwitchForWallboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.circuitBreakerAndSafetySwitchForWallboxAttachments"
              attachmentType="circuitBreakerAndSafetySwitchForWallboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('cablingBetweenWallboxAndDistributionAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.cablingBetweenWallboxAndDistributionAttachments"
              attachmentType="cablingBetweenWallboxAndDistributionAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Monitoring Section -->
            <legend>
              <strong>{{ $t('screenshotDeviceFlow') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.screenshotDeviceFlow"
              attachmentType="screenshotDeviceFlow"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('screenshotModeOfOperation') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.screenshotModeOfOperation"
              attachmentType="screenshotModeOfOperation"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('netConnectionTerms') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.netConnectionTerms"
              attachmentType="netConnectionTerms"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('monitoring') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.monitoringOptionalAttachments"
              attachmentType="monitoringOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Measurement Section -->
            <legend>
              <strong>{{ $t('measurementResultAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.measurementResultAttachments"
              attachmentType="measurementResultAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('measurementProtocolInclPhotosAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.measurementProtocolInclPhotosAttachments"
              attachmentType="measurementProtocolInclPhotosAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('measurements') }} {{ $t('optionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.measurementsOptionalAttachments"
              attachmentType="measurementsOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- Documents Section -->
            <legend>
              <strong>{{ $t('warrantyQCellsAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.warrantyQCellsAttachments"
              attachmentType="warrantyQCellsAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('acceptanceProtocolCustomerSignatureAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.acceptanceProtocolCustomerSignatureAttachments"
              attachmentType="acceptanceProtocolCustomerSignatureAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>
          </AccordionSimpleCard>

          <AccordionSimpleCard cardId="accordion-serviceReportAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('serviceReport') }}
                <ZipDownload
                  attachmentType="serviceReportImageAttachments"
                  :attachments="project.serviceReportImageAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>

            <!-- brickAndUk -->
            <legend>
              <strong>{{ $t('brickCoverWidthAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceBrickCoverWidthAttachments"
              attachmentType="serviceBrickCoverWidthAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('correctBrickHandlingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCorrectBrickHandlingAttachments"
              attachmentType="serviceCorrectBrickHandlingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('brickAndSubstructureAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceBrickAndSubstructureAttachments"
              attachmentType="serviceBrickAndSubstructureAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceCableAndPlugAttachedToRailStateAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCableAndPlugAttachedToRailStateAttachments"
              attachmentType="serviceCableAndPlugAttachedToRailStateAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('correctCableInputAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCorrectCableInputAttachments"
              attachmentType="serviceCorrectCableInputAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceRailOverlappingTerminationFittingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceRailOverlappingTerminationFittingAttachments"
              attachmentType="serviceRailOverlappingTerminationFittingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('protectedUnderBrickCableRoutingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceProtectedUnderBrickCableRoutingAttachments"
              attachmentType="serviceProtectedUnderBrickCableRoutingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong
                >{{ $t('brickAndSubstructureAttachments') }} {{ $t('optionalAttachments') }}</strong
              >
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceBrickAndSubstructureOptionalAttachments"
              attachmentType="serviceBrickAndSubstructureOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- solarPanels -->
            <legend>
              <strong>{{ $t('stringPlanAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceStringPlanAttachments"
              attachmentType="serviceStringPlanAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('allPanelsVisibleAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceAllPanelsVisibleAttachments"
              attachmentType="serviceAllPanelsVisibleAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('clampAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceClampAreaAttachments"
              attachmentType="serviceClampAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('trayfDistanceAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceTrayfDistanceAttachments"
              attachmentType="serviceTrayfDistanceAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceRailOverlapAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceRailOverlapAttachments"
              attachmentType="serviceRailOverlapAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('panelBottomViewAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.servicePanelBottomViewAttachments"
              attachmentType="servicePanelBottomViewAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('solarPanels') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceSolarPanelsOptionalAttachments"
              attachmentType="serviceSolarPanelsOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- cableManagement -->
            <legend>
              <strong>{{ $t('cableManagementAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCableManagementAttachments"
              attachmentType="serviceCableManagementAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('cableAlongFacadeAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCableAlongFacadeAttachments"
              attachmentType="serviceCableAlongFacadeAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong
                >{{ $t('cableManagementAttachments') }} {{ $t('optionalAttachments') }}</strong
              >
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCableManagementOptionalAttachments"
              attachmentType="serviceCableManagementOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- hak -->
            <legend>
              <strong>{{ $t('hakAndZsSameRoomAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serrviceHakLockedAttachments"
              attachmentType="serrviceHakLockedAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('hakAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceHakAttachments"
              attachmentType="serviceHakAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceHakAndZsSameRoomAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceHakAndZsSameRoomAttachments"
              attachmentType="serviceHakAndZsSameRoomAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- zs (electric meter cabinet) -->
            <legend>
              <strong>{{ $t('zsWithCoverAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsWithCoverAttachments"
              attachmentType="serviceZsWithCoverAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('zsWithoutCoverAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsWithoutCoverAttachments"
              attachmentType="serviceZsWithoutCoverAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceZsSerialNumberAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsSerialNumberAttachments"
              attachmentType="serviceZsSerialNumberAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceZsPostCounterAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsPostCounterAreaAttachments"
              attachmentType="serviceZsPostCounterAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceZsPreCounterAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsPreCounterAreaAttachments"
              attachmentType="serviceZsPreCounterAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceZsDistributionAreaAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceZsDistributionAreaAttachments"
              attachmentType="serviceZsDistributionAreaAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('additionalSubDistributionState') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceAdditionalSubDistributionAttachments"
              attachmentType="serviceAdditionalSubDistributionAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- electric_meter (inverter area) -->
            <legend>
              <strong>{{ $t('serviceDisassembledMetersAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceDisassembledMetersAttachments"
              attachmentType="serviceDisassembledMetersAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceMainElectricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceMainElectricMeterAttachments"
              attachmentType="serviceMainElectricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceSeconaryElectricMeterAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceSeconaryElectricMeterAttachments"
              attachmentType="serviceSeconaryElectricMeterAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- locationAndCable (installation location) -->
            <legend>
              <strong>{{ $t('installationLocationWithInverterAndMateboxState') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceInstallationLocationWithInverterAndMateboxAttachments"
              attachmentType="serviceInstallationLocationWithInverterAndMateboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceSecondaryInstallationLocationAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceSecondaryInstallationLocationAttachments"
              attachmentType="serviceSecondaryInstallationLocationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceCablePath360Attachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceCablePath360Attachments"
              attachmentType="serviceCablePath360Attachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceOpenMatebox') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceOpenMatebox"
              attachmentType="serviceOpenMatebox"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('mtbxLabelSnAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.mtbxLabelSnAttachments"
              attachmentType="mtbxLabelSnAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('invLabelSnAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.invLabelSnAttachments"
              attachmentType="invLabelSnAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('batLabelSnAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.batLabelSnAttachments"
              attachmentType="batLabelSnAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- earthingUnit -->
            <legend>
              <strong>{{ $t('serviceEarthingAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceEarthingAttachments"
              attachmentType="serviceEarthingAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- internetConnection (no AttachmentGallery-only states in form) -->

            <!-- wallbox -->
            <legend>
              <strong>{{ $t('serviceWallboxLocationAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceWallboxLocationAttachments"
              attachmentType="serviceWallboxLocationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceWallboxCablePathNotes') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceWallboxCablePathNotes"
              attachmentType="serviceWallboxCablePathNotes"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceWallboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceWallboxAttachments"
              attachmentType="serviceWallboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceWallboxAccessCardAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceWallboxAccessCardAttachments"
              attachmentType="serviceWallboxAccessCardAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <legend>
              <strong>{{ $t('serviceFiLsWallboxAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceFiLsWallboxAttachments"
              attachmentType="serviceFiLsWallboxAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>

            <!-- MISC -->
            <legend>
              <strong>{{ $t('serviceMiscOptionalAttachments') }}</strong>
            </legend>
            <AttachmentGallery
              v-bind="attachmentListAccess"
              :attachments="project.serviceMiscOptionalAttachments"
              attachmentType="serviceMiscOptionalAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentGallery>
          </AccordionSimpleCard>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <div class="accordion" role="tablist">
          <!-- Aufmaßprotokoll (automatisch generiert)  -->
          <AccordionSimpleCard cardId="accordion-documents-measurement-report">
            <template v-slot:header>
              <slot name="header"> {{ $t('measurementReport') }} ({{ $t('autoGenerated') }})</slot>
            </template>
            <div>
              <ButtonWait
                v-if="!isBlockReadOnly"
                :startCallback="startMeasurementReportBuild"
                :pollCallback="fetchMeasurementReportBuildState"
                class=""
              >
                <template v-slot:buttonText>
                  {{ $t('generate_report') }}
                </template>
              </ButtonWait>
              <router-link
                class="btn btn-success ml-2 mt-3"
                :to="{
                  name: 'MeasurementPrintPage',
                  params: { projectNumber: project.number },
                }"
                target="_blank"
              >
                <i class="fa fa-file mr-2"></i>{{ $t('preview') }}
              </router-link>
            </div>
            <AttachmentList
              v-bind="attachmentListAccess"
              v-if="
                project.measurementReportAttachments &&
                  project.measurementReportAttachmentsBuildState === 'FINISHED'
              "
              :attachments="project.measurementReportAttachments"
              attachmentType="measurementReportAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Abnahmeprotokoll (automatisch generiert)  -->
          <AccordionSimpleCard cardId="accordion-documents-acceptance-report">
            <template v-slot:header>
              <slot name="header"> {{ $t('acceptanceReport') }} ({{ $t('autoGenerated') }})</slot>
            </template>
            <div>
              <ButtonWait
                v-if="!isBlockReadOnly"
                :startCallback="startReportBuild"
                :pollCallback="fetchReportBuildState"
                class=""
              >
                <template v-slot:buttonText>
                  {{ $t('generate_report') }}
                </template>
              </ButtonWait>
              <router-link
                class="btn btn-success ml-2 mt-3"
                :to="{
                  name: 'ReportPrintPage',
                  params: { projectNumber: project.number },
                }"
                target="_blank"
              >
                <i class="fa fa-file mr-2"></i>{{ $t('preview') }}
              </router-link>
            </div>
            <AttachmentList
              v-bind="attachmentListAccess"
              v-if="project.reportAttachmentsBuildState === 'FINISHED'"
              :attachments="project.reportAttachments"
              attachmentType="reportAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Netzanmeldung (automatisch generiert) -->
          <AccordionSimpleCard cardId="accordion-documents-netRegistrationAttachmentsGenerated">
            <template v-slot:header>
              <slot name="header">
                {{ $t('netRegistrationAttachments') }} ({{ $t('autoGenerated') }})
                <ZipDownload
                  v-if="project.netRegistrationAttachmentsBuildState === 'FINISHED'"
                  attachmentType="netRegistrationAttachmentsGenerated"
                  :attachments="project.netRegistrationAttachmentsGeneratedZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>
            <p>
              <small>
                <strong v-if="project.powerCompany">{{ project.powerCompany.company }}</strong>
                {{ $t('is_approved_for_net_registration_generation') }} :
                <b-badge
                  v-if="project.powerCompany"
                  :variant="
                    getYesNoStateColor(project.powerCompany.netRegistrationDocumentsApprovedState)
                  "
                  >{{ $t(project.powerCompany.netRegistrationDocumentsApprovedState) }}</b-badge
                ></small
              >
            </p>
            <p>
              <ButtonWait
                v-if="
                  !isBlockReadOnly &&
                    project.client &&
                    project.client.name !== 'SOMV Project Consulting GmbH'
                "
                :startCallback="startNetRegistrationAttachmentsBuild"
                :pollCallback="updateNetRegistrationAttachmentsBuildState"
              >
                <template v-slot:buttonText>
                  {{ $t('generate_net_registration_attachments') }}
                </template>
              </ButtonWait>
            </p>
            <AttachmentList
              v-bind="attachmentListAccess"
              v-if="project.netRegistrationAttachmentsBuildState === 'FINISHED'"
              :attachments="project.netRegistrationAttachmentsGenerated"
              attachmentType="netRegistrationAttachmentsGenerated"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Netzanmeldung (hochgeladen) -->
          <AccordionSimpleCard cardId="accordion-documents-netRegistrationAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('netRegistrationAttachments') }} ({{ $t('uploaded') }})
                <ZipDownload
                  attachmentType="netRegistrationAttachments"
                  :attachments="project.netRegistrationAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.netRegistrationAttachments"
              attachmentType="netRegistrationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Downloads -->
          <AccordionSimpleCard cardId="accordion-documents-downloads">
            <template v-slot:header>
              <slot name="header">
                {{ $t('downloads') }} {{ $t('combinedNetRegistrationAttachmentsZip') }}
              </slot>
            </template>

            <p>
              {{ $t('combinedNetRegistrationAttachmentsZip') }}
              <ZipDownload
                attachmentType="combinedNetRegistrationAttachments"
                :attachments="project.combinedNetRegistrationAttachmentsZip"
                :project="project"
                :fetchBuildState="reloadBlock"
              />
            </p>
          </AccordionSimpleCard>

          <!-- Inbetriebnahmemeldung (automatisch generiert) -->
          <AccordionSimpleCard
            cardId="accordion-documents-operationRegistrationAttachmentsGenerated"
          >
            <template v-slot:header>
              <slot name="header">
                {{ $t('operationRegistrationAttachments') }} ({{ $t('autoGenerated') }})
                <ZipDownload
                  v-if="project.operationRegistrationAttachmentsBuildState === 'FINISHED'"
                  attachmentType="operationRegistrationAttachmentsGenerated"
                  :attachments="project.operationRegistrationAttachmentsGeneratedZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
              /></slot>
            </template>
            <p>
              <small>
                <strong v-if="project.powerCompany">{{ project.powerCompany.company }}</strong>
                {{ $t('is_approved_for_operation_registration_generation') }}:
                <b-badge
                  v-if="project.powerCompany"
                  :variant="
                    getYesNoStateColor(
                      project.powerCompany.operationRegistrationDocumentsApprovedState
                    )
                  "
                  >{{
                    $t(project.powerCompany.operationRegistrationDocumentsApprovedState)
                  }}</b-badge
                ></small
              >
            </p>
            <p>
              <ButtonWait
                v-if="
                  !isBlockReadOnly &&
                    project.client &&
                    project.client.name !== 'SOMV Project Consulting GmbH'
                "
                :startCallback="startoperationRegistrationAttachmentsBuild"
                :pollCallback="updateoperationRegistrationAttachmentsBuildState"
              >
                <template v-slot:buttonText>
                  {{ $t('generate_operation_registration_attachments') }}
                </template>
              </ButtonWait>
            </p>
            <AttachmentList
              v-bind="attachmentListAccess"
              v-if="project.operationRegistrationAttachmentsBuildState === 'FINISHED'"
              :attachments="project.operationRegistrationAttachmentsGenerated"
              attachmentType="operationRegistrationAttachmentsGenerated"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Inbetriebnahmemeldung (hochgeladen) -->
          <AccordionSimpleCard cardId="accordion-documents-operationRegistrationAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('operationRegistrationAttachments') }} ({{ $t('uploaded') }})
                <ZipDownload
                  attachmentType="operationRegistrationAttachments"
                  :attachments="project.operationRegistrationAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>

            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.operationRegistrationAttachments"
              attachmentType="operationRegistrationAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Übersichtsschaltbild (automatisch generiert) -->
          <AccordionSimpleCard cardId="accordion-documents-overviewSchematicAttachmentsGenerated">
            <template v-slot:header>
              <slot name="header">
                {{ $t('overviewSchematicAttachments') }} ({{ $t('autoGenerated') }})
                <ZipDownload
                  v-if="project.overviewSchematicAttachmentsBuildState === 'FINISHED'"
                  attachmentType="overviewSchematicAttachmentsGenerated"
                  :attachments="project.overviewSchematicAttachmentsGeneratedZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
                <span class="error ml-2" v-if="!requirementsValidState('overviewSchematic')">{{
                  invalidFeedbackNA
                }}</span>
              </slot>
            </template>
            <p>
              <ButtonWait
                v-if="
                  !isBlockReadOnly &&
                    project.client &&
                    project.client.name !== 'SOMV Project Consulting GmbH'
                "
                :startCallback="startOverviewSchematicAttachmentsBuild"
                :pollCallback="updateOverviewSchematicAttachmentsBuildState"
              >
                <template v-slot:buttonText>
                  {{ $t('generate_overview_schematic_attachments') }}
                </template>
              </ButtonWait>
            </p>
            <AttachmentList
              v-bind="attachmentListAccess"
              v-if="project.overviewSchematicAttachmentsBuildState === 'FINISHED'"
              :attachments="project.overviewSchematicAttachmentsGenerated"
              attachmentType="overviewSchematicAttachmentsGenerated"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Übersichtsschaltbild  (hochgeladen) -->
          <AccordionSimpleCard cardId="accordion-documents-overviewSchematicAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('overviewSchematicAttachments') }} ({{ $t('uploaded') }})
                <ZipDownload
                  attachmentType="overviewSchematicAttachments"
                  :attachments="project.overviewSchematicAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
                <span class="error" v-if="!requirementsValidState('overviewSchematic')">{{
                  invalidFeedbackNA
                }}</span>
              </slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.overviewSchematicAttachments"
              attachmentType="overviewSchematicAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Vollmacht -->
          <AccordionSimpleCard cardId="accordion-documents-mandateAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('mandateAttachments') }}
                <ZipDownload
                  attachmentType="mandateAttachments"
                  :attachments="project.mandateAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
                <span class="error" v-if="!requirementsValidState('mandateState')">{{
                  invalidFeedbackNA
                }}</span></slot
              >
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.mandateAttachments"
              attachmentType="mandateAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Lageplan -->
          <AccordionSimpleCard cardId="accordion-documents-layoutPlanAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('layoutPlanAttachments') }}
                <ZipDownload
                  attachmentType="layoutPlanAttachments"
                  :attachments="project.layoutPlanAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
                <span class="error" v-if="!requirementsValidState('layoutPlanState')">{{
                  invalidFeedbackNA
                }}</span>
              </slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.layoutPlanAttachments"
              attachmentType="layoutPlanAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Projektbeschreibung -->
          <AccordionSimpleCard cardId="accordion-documents-projectDescriptionAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('projectDescriptionAttachments') }}
                <ZipDownload
                  attachmentType="projectDescriptionAttachments"
                  :attachments="project.projectDescriptionAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
              /></slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.projectDescriptionAttachments"
              attachmentType="projectDescriptionAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Angebote -->
          <AccordionSimpleCard cardId="accordion-documents-offerAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('offerAttachments') }}
                <ZipDownload
                  attachmentType="offerAttachments"
                  :attachments="project.offerAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.offerAttachments"
              attachmentType="offerAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Rechnungen -->
          <AccordionSimpleCard cardId="accordion-documents-invoiceAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('invoiceAttachments') }}
                <ZipDownload
                  attachmentType="invoiceAttachments"
                  :attachments="project.invoiceAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
                />
              </slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.invoiceAttachments"
              attachmentType="invoiceAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Service Contract Attachments -->
          <AccordionSimpleCard cardId="accordion-documents-serviceContractAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('serviceContractAttachments') }}
                <!-- <ZipDownload
                  attachmentType="serviceContractAttachments"
                  :attachments="project.serviceContractAttachmentsZip"
                  :project="project"
                  :light="true"
                /> -->
              </slot>
            </template>

            <!-- Upload Section -->

            <DropzoneUpload
              v-if="!isBlockReadOnly"
              class="mt-1"
              :complete="isServiceContractUploadComplete"
              :parentId="project.id"
              :parentType="'SERVICE_CONTRACT'"
              :uploadCallback="onUploadServiceContractAttachments"
              :multiUpload="true"
              v-on:dropzone-upload:reset="isServiceContractUploadComplete = false"
            />

            <!-- Attachments List -->
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="serviceContractAttachments"
              attachmentType="serviceContractAttachments"
              v-on:attachment-list:delete="onDeleteServiceContractAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>

          <!-- Weitere Dokumente -->
          <AccordionSimpleCard cardId="accordion-documents-miscAttachments">
            <template v-slot:header>
              <slot name="header">
                {{ $t('miscAttachments') }}
                <ZipDownload
                  attachmentType="miscAttachments"
                  :attachments="project.miscAttachmentsZip"
                  :project="project"
                  :fetchBuildState="reloadBlock"
                  :light="true"
              /></slot>
            </template>
            <AttachmentList
              v-bind="attachmentListAccess"
              :attachments="project.miscAttachments"
              attachmentType="miscAttachments"
              v-on:attachment-list:delete="onDeleteProjectAttachment"
            ></AttachmentList>
          </AccordionSimpleCard>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentList from '@/components/AttachmentList';
import AttachmentGallery from '@/components/AttachmentGallery';
import ZipDownload from '@/components/ZipDownload';
import ButtonWait from '@/components/ButtonWait.vue';
import { getYesNoStateColor } from '@/helpers/colors';
import AccordionSimpleCard from '@/components/AccordionSimpleCard';
import { AccessBlockMixin } from '@/mixins/accessBlock';

/** Number of the unsaved project (ProjectEdit `_new`): the block needs a saved project. */
const NEW_PROJECT_NUMBER = '_new';
const FINISHED_BUILD_STATE = 'FINISHED';

/**
 * Block project-documents: the whole tab Dokumente (see feature page projekt-dokumente). `project`
 * is the block data (`Project.blocks.documents`), a project-shaped excerpt; every operation keeps
 * its legacy action and then reloads the block. Matrix-Authz: only the block level counts; viewer
 * sees and downloads files and ZIPs, editor also uploads, deletes and generates. Legacy-Authz: the
 * type list by the old role CLIENT and the guest rule of the lists as before. The SOMV rule is an
 * organization rule and applies in both modes.
 */
export default {
  name: 'ProjectDocuments',
  mixins: [AccessBlockMixin],
  components: {
    Multiselect,
    DropzoneUpload,
    AttachmentList,
    AttachmentGallery,
    ZipDownload,
    ButtonWait,
    AccordionSimpleCard,
  },
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return {
      selectedProjectAttachmentType: null,
      filteredProjectAttachmentTypes: [],
      isAttachmentUploadComplete: false,
      isServiceContractUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin',
      'isClient',
      'getCurrentUser',
      'isOrganizationRoleNavigationEnabled',
    ]),
    ...mapGetters(['getEnumValues']),
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
    isUploadVisible() {
      return !this.isNewProject && !this.isBlockReadOnly;
    },
    /** Delete by the block level; Matrix-Authz without the lists' own guest rule. */
    attachmentListAccess() {
      return {
        deletable: !this.isBlockReadOnly,
        hidesDeleteForGuests: !this.isOrganizationRoleNavigationEnabled,
      };
    },
    /** Matrix-Authz: every type with editor; Legacy-Authz: the employer types for the role CLIENT. */
    projectAttachmentTypeEnum() {
      const hasAllTypes = this.isOrganizationRoleNavigationEnabled || !this.isClient;
      return hasAllTypes ? 'ProjectAttachmentType' : 'EmployerProjectAttachmentType';
    },
    isUploadDisabled() {
      return this.selectedProjectAttachmentType === null ? true : false;
    },
    /**
     * Get service contract attachments from the unified attachment system
     */
    serviceContractAttachments() {
      if (!this.project || !this.project.attachments) return [];
      return this.project.attachments.filter(
        (attachment) => attachment.attachmentType === 'SERVICE_CONTRACT'
      );
    },
    /**
     * @todo DRY
     */
    invalidFeedbackNA() {
      return 'Voraussetzung NA';
    },
  },
  methods: {
    ...mapActions([
      'uploadProjectAttachment',
      'deleteProjectAttachment',
      'uploadProjectDynamicAttachment',
      'deleteProjectDynamicAttachment',
      'fetchNetRegistrationAttachmentsBuildState',
      'fetchOperationRegistrationAttachmentsBuildState',
      'fetchOverviewSchematicAttachmentsBuildState',
      'buildNetRegistration',
      'buildOperationRegistration',
      'buildOverviewSchematic',
      'buildReport',
      'fetchReportAttachmentsBuildState',
      'buildMeasurementReport',
      'serviceMeasurementReport',
      'fetchMeasurementReportAttachmentsBuildState',
      'fetchProjectOfferAttachmentsBuildState',
      'buildProjectOffer',
      'fetchProjectDocumentsBlock',
    ]),
    reloadBlock() {
      return this.fetchProjectDocumentsBlock(this.project.number);
    },
    /**
     * Build state from the reloaded block, for ButtonWait; null when the reload failed, so
     * ButtonWait keeps polling. On FINISHED the legacy action refreshes the generated list and
     * state of the page project once, for the tabs Abnahme and Aufmaß.
     */
    async pollBuildState(buildStateField, fetchLegacyBuildState) {
      const block = await this.reloadBlock();
      if (!block) {
        return null;
      }
      if (block[buildStateField] === FINISHED_BUILD_STATE) {
        await fetchLegacyBuildState(this.project.number);
      }
      return block[buildStateField];
    },
    /** @todo changes to project are lost */
    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
      await this.reloadBlock();
    },
    /** The block reload also brings the recomputed requirement hints (e.g. layout plan). */
    async onUploadProjectAttachments(payload) {
      for (const file of payload.files) {
        await this.uploadProjectAttachment({
          file,
          parentId: payload.parentId,
          parentType: payload.parentType,
        });
      }
      await this.reloadBlock();
    },
    /**
     * Handle service contract attachment upload using dynamic attachment system
     */
    async onUploadServiceContractAttachments(payload) {
      for (const file of payload.files) {
        await this.uploadProjectDynamicAttachment({
          file,
          parentId: payload.parentId,
          parentType: payload.parentType,
        });
      }
      await this.reloadBlock();
    },
    /**
     * Handle service contract attachment deletion using dynamic attachment system
     */
    async onDeleteServiceContractAttachment(event) {
      await this.deleteProjectDynamicAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
      });
      await this.reloadBlock();
    },
    onProjectAttachmentTypeSearch(query) {
      this.filteredProjectAttachmentTypes = [];
      this.getProjectAttachmentTypes.map((projectAttachmentType) => {
        if (
          this.$t(projectAttachmentType)
            .toLowerCase()
            .indexOf(query) >= 0
        ) {
          this.filteredProjectAttachmentTypes.push(projectAttachmentType);
        }
      });
    },
    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startNetRegistrationAttachmentsBuild() {
      if (this.project) {
        await this.buildNetRegistration(this.project.id);
      }
    },

    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    updateNetRegistrationAttachmentsBuildState() {
      return this.pollBuildState(
        'netRegistrationAttachmentsBuildState',
        this.fetchNetRegistrationAttachmentsBuildState
      );
    },

    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startoperationRegistrationAttachmentsBuild() {
      if (this.project) {
        await this.buildOperationRegistration(this.project.id);
      }
    },

    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    updateoperationRegistrationAttachmentsBuildState() {
      return this.pollBuildState(
        'operationRegistrationAttachmentsBuildState',
        this.fetchOperationRegistrationAttachmentsBuildState
      );
    },

    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startOverviewSchematicAttachmentsBuild() {
      if (this.project) {
        await this.buildOverviewSchematic(this.project.id);
      }
    },

    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    updateOverviewSchematicAttachmentsBuildState() {
      return this.pollBuildState(
        'overviewSchematicAttachmentsBuildState',
        this.fetchOverviewSchematicAttachmentsBuildState
      );
    },

    /**
     * check requirementsValidState to show mark input fields
     * @todo DRY
     */
    requirementsValidState(field) {
      if (!this.project.netRegistrationRequirements) return false;

      const requirement = this.project.netRegistrationRequirements.find(
        (requirement) => requirement.name === field
      );
      return requirement && requirement.fullfilledState === 'YES' ? true : false;
    },

    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startReportBuild() {
      if (this.project) {
        await this.buildReport(this.project.id);
      }
    },
    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    fetchReportBuildState() {
      return this.pollBuildState(
        'reportAttachmentsBuildState',
        this.fetchReportAttachmentsBuildState
      );
    },

    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startMeasurementReportBuild() {
      if (this.project) {
        await this.buildMeasurementReport(this.project.id);
      }
    },
    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    fetchMeasurementReportBuildState() {
      return this.pollBuildState(
        'measurementReportAttachmentsBuildState',
        this.fetchMeasurementReportAttachmentsBuildState
      );
    },

    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    updateProjectOfferBuildState() {
      this.fetchProjectOfferAttachmentsBuildState(this.project.number);
      return this.project.projectOfferAttachmentsBuildState;
    },

    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startProjectOfferBuild() {
      if (this.project) {
        await this.buildProjectOffer(this.project.id);
      }
    },

    getYesNoStateColor,
  },

  async mounted() {
    this.filteredProjectAttachmentTypes = this.getEnumValues(this.projectAttachmentTypeEnum);

    // console.log(this.filteredProjectAttachmentTypes);

    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isAttachmentUploadComplete = true;
        }
        if (action.type === 'uploadProjectDynamicAttachment') {
          this.isServiceContractUploadComplete = true;
        }
      },
    });
  },
};
</script>
<style lang="scss">
.error {
  color: $danger;
}
</style>
